"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recentTeam = exports.teamsLoaded = exports.getTeams = exports.retiredTeams = exports.activeTeams = exports.teams = void 0;
const teams = (state) => state.teams;
exports.teams = teams;
const activeTeams = (state) => (0, exports.teams)(state).activeTeams;
exports.activeTeams = activeTeams;
const retiredTeams = (state) => (0, exports.teams)(state).retiredTeams;
exports.retiredTeams = retiredTeams;
const getTeams = (state) => (0, exports.teams)(state).teams;
exports.getTeams = getTeams;
const teamsLoaded = (state) => (0, exports.teams)(state).teamsLoaded;
exports.teamsLoaded = teamsLoaded;
const recentTeam = (state) => (0, exports.teams)(state).recentTeam;
exports.recentTeam = recentTeam;
